export default "__VITE_ASSET__DpGxBww6__"